
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { searchCustomer } from "@/api/customer";
import { getSuppliersList } from "@/api/inquiry";
import {
  getList,
  getStatus,
  setRemark,
  hangUp,
  cancelHangUp,
  review,
  invalid,
  putSettlementPeriod,
  putCancelInvalid,
  putResetting,
  getPaymentType,
  getAccountPeriodType
} from "@/api/supplier-payment";

import {
  getSalesmanList,
  removeQuotation,
  generatePI,
  auditPass,
} from "@/api/inquiry";
import {
  getPiDeliveryStatus,
  getPiCustomerShipmentStatus,
  confirmOrder,
  invalidPi,
  uncancelPi,
} from "@/api/proforma";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import { getAccountPeriod,postOptional } from "@/api/hq-packing-list"
import { getUsersByJobPosition } from "@/api/users";
import {INVOICE_RE_STATUS} from "@/constant";

@Component({
  name: "supplierPaymentManagement",
  components: {
    Pagination,
    payment: () => import("./components/payment.vue"),
  },
})
export default class extends Vue {
  private settlementPeriodShow = false; // 结算账期SHOW
  private isShowMore = false;
  private listLoading = true;
  private showView = false;
  private showClaim = false;
  private isAnnual = false;
  private showReceipt = false;
  private showFile = false;
  private showVer = false;
  private showPay = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public info = {} as any;
  public infoFields = [
    {
      label: "供应商编号",
      key: "customerAbbreviation",
    },
    {
      label: "供应商简称",
      key: "createdTime",
    },
  ] as any;
  private settlementList = [
    {
      label: "账期到期日",
      prop: "endTime",
      key: "endTime",
      type: "datetime",
      placeholder: "请选择账期到期日",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择账期到期日",
        trigger: "change",
      },
    },
  ];
  private settlementForm = {
    endTime: "",
  };
  public listParam = {
    inquirySheetCode: null,
    customerId: null,
    startTime: null,
    endTime: null,
    sellerId: null,
    status: null,
    time: [],
    paymentVoucherType: null,
    accountPeriodType: null,
    bookingOrderCodeKeyword: null,
  };
  public searchForm = [
    {
      label: "付款单号",
      prop: "code",
      key: "code",
      type: "input",
      value: "",
      placeholder: "请输入付款单号",
    },
    {
      label: "付款日期",
      prop: "time",
      key: "time",
      type: "dateTimePicker",
      value: "",
      placeholder: "",
    },
    {
      label: "付款供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "状态",
      prop: "state",
      key: "state",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      // resetKey: { label: "desc", value: "name" },
    },
    {
      label: "付款性质",
      prop: "paymentVoucherType",
      key: "paymentVoucherType",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "账期类型",
      prop: "accountPeriodType",
      key: "accountPeriodType",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "采购员",
      prop: "purchaser",
      key: "purchaser",
      type: "select",
      value: "",
      placeholder: "请输入采购员",
      options: [],
      // resetKey: { label: "desc", value: "name" },
    },

    {
      label: "业务会计",
      prop: "accountant",
      key: "accountant",
      type: "select",
      value: "",
      placeholder: "请输入业务会计",
    },
    {
      label: "采购订单",
      prop: "relationPurchaseOrder",
      key: "relationPurchaseOrder",
      type: "input",
      value: "",
      placeholder: "请输入采购订单",
    },
    {
      label: "装箱单",
      prop: "relationPackingList",
      key: "relationPackingList",
      type: "input",
      value: "",
      placeholder: "请输入装箱单",
    },
    {
      label: "报关合同",
      prop: "bookingOrderCodeKeyword",
      key: "bookingOrderCodeKeyword",
      type: "input",
      value: "",
      placeholder: "请输入报关合同",
    },
    {
      label: "付款核销",
      prop: "reconciliationStatus",
      key: "reconciliationStatus",
      type: "select",
      clearable: true,
      options: INVOICE_RE_STATUS,
      value: "",
      resetKey: {label: "name", value: "value"},
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      disabled: false,
      fixed: true,
      icon: require("@/assets/images/icon_HT.jpg"),
      icon_key: "rolledBack",
      icon_value: true,
    },
    {
      label: "付款单号",
      prop: "code",
      key: "code",
      type: "link",
      show: true,
      disabled: false,
      width: "150px",
    },
    {
      label: "付款供应商",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
    },
    {
      label: "付款类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false,
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false,
    },
    {
      label: "单据剩余",
      prop: "paymentRemaining",
      key: "paymentRemaining",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单费用剩余",
      prop: "purchaseOrderFeeRemaining",
      key: "purchaseOrderFeeRemaining",
      show: true,
      disabled: false,
    },
    {
      label: "未核销金额",
      prop: "unAllocateAmount",
      key: "unAllocateAmount",
      show: true,
      disabled: false,
    },
    {
      label: "约定账期",
      prop: "agreedAccountPeriod",
      key: "agreedAccountPeriod",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "采购员",
      prop: "purchaser",
      key: "purchaser",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "业务会计",
      prop: "accountant",
      key: "accountant",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "销售员",
      prop: "seller",
      key: "seller",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "创建人",
      prop: "createdBy",
      key: "createdBy",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "创建日期",
      prop: "createdDate",
      key: "createdDate",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "状态",
      prop: "state",
      key: "state",
      show: true,
      disabled: false,
    },

    {
      label: "付款时间",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "付款",
          code: ["payment"],
          click: "handlePay",
          key: "state",
          value: "待付款",
        },
        {
          prop: "paymentTime",
          type: "textLine"
        },
      ],
      show: true,
      disabled: false,
      width: 130,
    },
    {
      label: "审核",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "审核",
          code: ["audit"],
          click: "handleReview",
          key: "state",
          value: "待审核",
        },
        {
          name: "已审核",
          code: "",
          key: "state",
          value: "已审核",
        },
        {
          name: "挂起",
          code: ["hang"],
          click: "handleAuditHold",
          key: "state",
          value: "待审核,待付款",
        },
        {
          name: "取消挂起",
          code: "",
          click: "cancelAuditHold",
          key: "state",
          value: "已挂起",
        },
        {
          name: "取消审核",
          code: ["cancelAudit"],
          click: "cancelExamine",
          key: "state",
          value: "待付款",
        },
        {
          name: "作废",
          code: ["cancel"],
          click: "handleInvalid",
          key: "state",
          value: "待审核,已审核,已挂起,待付款",
        },
        {
          name: "取消作废",
          code: ["cancel"],
          click: "handleCancelInvalid",
          key: "state",
          value: "已作废",
        },
      ],
      show: true,
      disabled: false,
      width: 210,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        // {
        //   name: "更新（重置）",
        //   code: "",
        //   click: "handleUpdate",
        //   key: "state",
        //   value: "待审核,待付款",
        // },
        {
          name: "单据流",
          code: "",
          click: "gotoDocumentFlow",
        },
      ],
      show: true,
      disabled: false,
      width: 200,
    },
    {
      label: "采购订单",
      prop: "relationPurchaseOrder",
      key: "relationPurchaseOrder",
      show: true,
      disabled: false,
      width: 130,
      show_key: "show1",
    },
    {
      label: "装箱单",
      prop: "relationPackingList",
      key: "relationPackingList",
      show: true,
      disabled: false,
      width: 130,
      show_key: "show1",
    },
    {
      label: "报关合同",
      prop: "bookingOrderCode",
      key: "bookingOrderCode",
      show: true,
      disabled: false,
      width: 130,
      show_key: "show1",
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      code: ["remark"],
      type: "remark",
      length: 255,
      show: true,
      disabled: false,
    },
  ] as any;

  created() {
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getSalesmanList();
    this.getStatus();
    this.getList();
    this.getPaymentType();
    this.getAccountPeriodType();
    this.getSellerList();
    this.getAccountantList();
  }

  private async getSellerList() {
    const res: any = await getUsersByJobPosition("purchaser");
    this.searchForm[6].options = res;
  }

  private async getAccountantList() {
    const res: any = await getUsersByJobPosition("financial_accountant");
    this.searchForm[7].options = res;
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[2].options = res;
  }

  private async getStatus() {
    const res: any = await getStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[3].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, list }: any = await getList(params);
    this.table.total = +total;
    this.table.list = list;
    this.table.list.map((e,index) => {
      e.sn = index + 1
    })
    this.table.list.forEach((item) => {
      item.relationPackingList = item.relationPackingList
        ? item.relationPackingList
        : "未关联";
      item.relationPurchaseOrder = item.relationPurchaseOrder
        ? item.relationPurchaseOrder
        : "未关联";
      item.showPay = item.paymentTime ? false : true;
    });
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  // 导出excel
  private isExporting = false;

  // 导出
  public handleExport() {
    if (this.selectedRows.length > 0) {
      this.isExporting = true;
      let table = this.tableCol.slice(0, this.tableCol.length - 1);
      const headers = table.map((v) => v.label);
      const fieldNames = table.map((v) => v.key);
      let list = deepClone(this.selectedRows);
      exportJson2Excel(
        headers,
        formatJson(fieldNames, list),
        `付款单-${new Date()}`
      );
      this.isExporting = false;
      (this.$refs.table as any).$refs.table.clearSelection();
    } else {
      this.$notify({
        title: "提示",
        message: "请选择需要导出的数据",
        type: "warning",
        duration: 2000,
      });
    }
  }

  public handleView(scope) {
    this.selectedItem = scope.row;
    this.showView = true;
  }

  private cancelAuditHold(scope) {
    this.$confirm("确定取消挂起吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await cancelHangUp(scope.row.id);
        this.$notify({
          title: "成功",
          message: "取消成功",
          type: "success",
          duration: 2000,
        });

        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private cancelExamine(scope) {
    this.$confirm("确定取消审核吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await cancelHangUp(scope.row.id);
        this.$notify({
          title: "成功",
          message: "取消成功",
          type: "success",
          duration: 2000,
        });

        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //
  // private editAuditHold() {
  //   this.$prompt("请输入挂起原因", "编辑挂起原因", {
  //     confirmButtonText: "确定",
  //     cancelButtonText: "取消",
  //     inputType: "textarea"
  //   })
  //     .then(async ({ value }: any) => {
  //       if (!value) {
  //         this.$message.error("请输入挂起原因");
  //         return;
  //       }
  //       await hangUp({
  //         id: this.customerInfo.approvalRecordId,
  //         remark: value
  //       });
  //       this.$notify({
  //         title: "成功",
  //         message: "编辑挂起原因成功",
  //         type: "success",
  //         duration: 2000
  //       });
  //       this.getList();
  //     })
  //     .catch(() => {
  //       // empty
  //     });
  // }
  //
  // // 挂起

  private async settlementPeriodSubmit() {
    console.log("settlementForm", this.settlementForm);
    if (this.settlementForm.endTime) {
      var myDate = new Date();
      var fullYear = myDate.getFullYear();
      var m =
        myDate.getMonth() + 1 >= 10
          ? myDate.getMonth() + 1
          : `0${myDate.getMonth() + 1}`;
      var d =
        myDate.getDate() >= 10 ? myDate.getDate() : `0${myDate.getDate()}`;
      var newTime = `${fullYear}-${m}-${d}`;
      const params = {
        start: newTime,
        end: this.settlementForm.endTime,
      };
      await putSettlementPeriod(params);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.settlementPeriodShow = false;
    } else {
      this.$notify({
        title: "请选择账期到期日",
        message: "请选择账期到期日",
        type: "error",
        duration: 2000,
      });
    }
  }
  private async handleAuditHold(scope) {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await hangUp(scope.row.id, {
          remark: value,
        });
        this.$notify({
          title: "成功",
          message: "挂起成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }

  private async getPaymentType() {
    await getPaymentType().then((res:any) => {
      this.searchForm.find(e => e.key === 'paymentVoucherType').options = res
    });
  }

  private async getAccountPeriodType() {
    await getAccountPeriodType().then((res:any) => {
      this.searchForm.find(e => e.key === 'accountPeriodType').options = res
    });
  }

  public handleVerification(item) {
    this.selectedItem = item;
    this.showVer = true;
  }

  // 查看回执
  public async handleReceipt(scope) {
    // this.selectedItem = scope.row;
    this.showReceipt = true;
  }

  // 文件管理
  public async handleFile(scope) {
    this.selectedItem = scope.row;
    this.showFile = true;
  }

  public handlePay(scope) {
    this.selectedItem = scope?.row || {};
    this.showPay = true;
  }

  private handleSuccess() {
    this.showPay = false;
    this.showView = false;
    this.showClaim = false;
    this.selectedItem = {};
    this.getList();
  }

  //  删除
  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 付款单跳转单据流
  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "PAYMENT_VOUCHER", documentId: data.row.id },
    });
  }

  // 审批通过
  public async handleAuditPass(scope) {
    this.$confirm("确定审批通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(scope.row.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审批通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private handlePI(scope) {
    this.$alert(scope.row.approvalRecordId, "PI号码", {
      confirmButtonText: "复制",
      callback: () => {
        this.h5Copy(scope.row.approvalRecordId);
      },
    });
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      await setRemark(item.id, {
        remark: item.remark,
      });
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  private async putResetting(row) {
    this.$confirm("确定更新（重置）吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await putResetting(row.row.id);
        this.confirmSuccess();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private h5Copy(content) {
    if (!document.queryCommandSupported("copy")) {
      // 不支持
      return false;
    }
    let textarea = document.createElement("textarea") as any;
    textarea.value = content;
    textarea.readOnly = "readOnly";
    document.body.appendChild(textarea);
    textarea.select(); // 选择对象
    textarea.setSelectionRange(0, content.length); // 核心
    let result = document.execCommand("copy"); // 执行浏览器复制命令
    textarea.remove();
    this.$notify({
      title: "成功",
      message: "复制成功",
      type: "success",
      duration: 2000,
    });
    return result;
  }

  private async handleUpdate(row) {
    this.$confirm("确定更新吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await putResetting(row.row.id);
        this.confirmSuccess();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleCancelInvalid(row) {
    this.$confirm("确定取消作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await putCancelInvalid(row.row.id);
        this.confirmSuccess();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[6].options = res;
  }

  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[1].options = res;
  }

  private async getPiCustomerShipmentStatus() {
    const res: any = await getPiCustomerShipmentStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[7].options = res;
    this.tableCol.find((item) => item.key === "shipmentStatus").typeList = res;
  }

  private async getPiDeliveryStatus() {
    const res: any = await getPiDeliveryStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[6].options = res;
    this.tableCol.find((item) => item.key === "status").typeList = res;
  }

  public querySearch(data) {
    const params = Object.assign({}, data);
    const { time, ...rest } = params;
    if (time && time.length) {
      rest.paymentStartDate = time[0];
      rest.paymentEndDate = time[1];
    }
    console.log(rest);
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private handleCustomer() {
    // empty
  }

  private linkClick(scope) {
    this.$router.push(`/paymentOrderDetails?id=${scope.row.id}`);
  }

  public selectedItem = {} as any;

  // 编辑
  public async handleEdit(scope) {
    this.selectedItem = scope.row;
    this.showClaim = true;
  }

  public async handleClaim(scope) {
    this.selectedItem = scope.row;
    this.isAnnual = false;
    this.showClaim = true;
  }

  public async handleAnnualClaim(scope) {
    this.selectedItem = scope.row;
    this.isAnnual = true;
    this.showClaim = true;
  }

  private handleOrderManage(scope) {
    let item = JSON.stringify(scope.row);
    if (item.indexOf("&") != -1) {
      item = item.replace("&", "replace");
    }
    this.$router.push(`/managePurchaseOrders?id=${scope.row.id}&item=${item}`);
  }


  private async handleInvalidPi(scope) {
    this.$confirm("确定作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await invalidPi(scope.row.id);
        this.confirmSuccess();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleReview(scope) {
    this.$confirm("确定审核通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await review(scope.row.id);
        this.$notify({
          title: "成功",
          message: "审核通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleInvalid(scope) {
    this.$confirm("确定作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await invalid(scope.row.id);
        this.$notify({
          title: "成功",
          message: "操作通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleDeduction(scope) {
    this.$confirm("", "部分抵扣", {
      confirmButtonText: "强制核销",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await this.handleVerification(scope.row);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleUncancelPi(scope) {
    this.$confirm("确定取消作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await uncancelPi(scope.row.id);
        this.confirmSuccess();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 点击是否展示所有产品号码
  private showMore() {
    this.isShowMore = !this.isShowMore;
  }

  private selectedRows: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.selectedRows = rows;
  }

  private showSettleAnAccount = false;
  private showSettleLoading = false;
  private settleAnAccountOptions = [] as any;
  private changeOptions = [];
  private async filterSettleAnAccount(value) {
    if(value) {
      let params = {
        keyword:value
      }
      await getAccountPeriod(params).then((res:any) => {
        this.settleAnAccountOptions = res.map(item => {
          return {
            value: item,
            label: item
          }
        })
        if(this.changeOptions.length > 0) {
          this.changeOptions.forEach(e => { this.settleAnAccountOptions.push({value: e[0],label: e[0]}) })
        }
      }).catch(err => {
        console.log(err);
      })
    } else {
      this.settleAnAccountOptions = []
    }
  }
  private showSettleAnAccountClose() {
    this.showSettleAnAccount = false;
    this.settleAnAccountOptions = [];
    this.changeOptions = [];
  }
  private handleSettleAnAccount() {
    this.showSettleAnAccount = true;
  }
  private async settleAnAccountSubmit() {
    if(this.changeOptions.length === 0) {
      this.$notify({
        title: "提示",
        message: "请选择需要搜索饿装箱单号！",
        type: "warning",
        duration: 2000,
      });
      return
    }
    let data = this.changeOptions.map(e => {return e[0]});
    this.showSettleLoading = true;
    await postOptional(data).then(res => {
      this.showSettleAnAccount = false;
      this.showSettleLoading = false;
      this.changeOptions = [];
      this.getList();
      this.$notify({
        title: "提示",
        message: "操作成功！",
        type: "success",
        duration: 2000,
      });
    }).catch(err => {
      console.log(err);
      this.showSettleLoading = false;
    })
  }
}
